import { Sheet, Table } from "@mui/joy";
import type {
  QualificationItem,
  QualificationDraft,
} from "../../../../api/qualification/Qualification.typed";
import { hrSheetSx, hrTableSx } from "../../../../styles/globalStyles";
import QualificationCreateRow from "./QualificationCreateRow";
import QualificationItemRow from "./QualificationItemRow";

export type QualificationsTableProps = {
  items: QualificationItem[];
  editingId: number | null;
  draft: QualificationDraft;
  loading: boolean;
  canEdit: boolean;
  onDraftChange: (patch: Partial<QualificationDraft>) => void;
  onSave: () => void;
  onCancelEdit: () => void;
  onStartEdit: (item: QualificationItem) => void;
  onRemove: (id: number) => void;
};

export default function QualificationsTable({
  items,
  editingId,
  draft,
  loading,
  canEdit,
  onDraftChange,
  onSave,
  onCancelEdit,
  onStartEdit,
  onRemove,
}: QualificationsTableProps) {
  return (
    <Sheet sx={hrSheetSx}>
      <Table hoverRow sx={hrTableSx}>
        <thead>
          <tr>
            <th>Sigle</th>
            <th>Nom</th>
            <th>Description</th>
            {canEdit && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {canEdit && editingId === 0 && (
            <QualificationCreateRow
              draft={draft}
              loading={loading}
              onDraftChange={onDraftChange}
              onSave={onSave}
              onCancel={onCancelEdit}
            />
          )}
          {items.map((item) => (
            <QualificationItemRow
              key={item.id}
              item={item}
              isEditing={editingId === item.id}
              draft={draft}
              canEdit={canEdit}
              loading={loading}
              onDraftChange={onDraftChange}
              onSave={onSave}
              onCancel={onCancelEdit}
              onEdit={() => onStartEdit(item)}
              onRemove={() => onRemove(item.id)}
            />
          ))}
        </tbody>
      </Table>
    </Sheet>
  );
}
